// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"56711907","196":"a42634d2","357":"8240aead","383":"b791f3a0","401":"9c0f5bef","415":"e0450978","476":"3ee338e1","532":"20427b8b","791":"8247f28b","846":"c03b12bc","867":"477320ee"}[chunkId] + ".chunk.js";
};